<template>
    <div class="draggable">
        <div class="flex border-collapse border-b border-gray-200"
             :class="backgroundColor()+(singleColumn?' border-t':'')">
            <div class="w-6 flex-shrink-0">
                <div class="px-2 py-2 w-5 h-5 flex jobs-center">
                    <i class="fa fa-bars fa-fw text-xs text-gray-300 hover:text-gray-400 cursor-move handle"></i>
                </div>
            </div>
            <template v-if="!singleColumn">
                <div class="flex-1 border-l border-r border-gray-200 px-0 py-0 ">
                    <div v-if="job.status!=='Awaiting'" class="text-sm m-0 px-2 py-1" style="white-space: pre-wrap">
                        {{ job.address ? job.address : "&nbsp;" }}
                    </div>
                    <route-plan-address-search
                        v-else
                        class="col-span-full"
                        #default="{ open, query, setQuery }"
                        @selected:packageAddress="addressSelected"
                        :top="true"
                    >
                        <autoresizable-textarea :height="getHeight">
                    <textarea
                        placeholder="Address..."
                        class="text-sm px-2 py-1 mb-0 border-0 shadow-none relative hover:z-20 focus:z-20 resize-none "
                        :class="backgroundColor()"
                        type="text"
                        ref="address"
                        v-model="job.address"
                        rows="1"
                        @input="setQuery($event.target.value);save()"
                        @focus="editingAddress($event.target,open);setQuery($event.target.value)"
                    ></textarea>
                        </autoresizable-textarea>
                    </route-plan-address-search>
                </div>
                <div class="flex-1 border-r border-gray-200 px-0 py-0">
                    <div v-if="job.status!=='Awaiting'" class="text-sm m-0 px-2 py-1" style="white-space: pre-wrap">
                        {{ job.contact ? job.contact : "&nbsp;" }}
                    </div>
                    <route-plan-contact-search
                        v-else
                        class="col-span-full"
                        #default="{ open, query, setQuery }"
                        @selected:deliveryContact="contactSelected"
                        :top="true"
                    >
                        <autoresizable-textarea :height="getHeight">
                    <textarea
                        placeholder="Contact..."
                        class="text-sm px-2 py-1 mb-0 border-0 shadow-none relative hover:z-10 focus:z-20 resize-none"
                        :class="backgroundColor()"
                        type="text"
                        ref="contact"
                        v-model="job.contact"
                        rows="1"
                        @input="setQuery($event.target.value);save()"
                        @focus="editingContact($event.target,open);setQuery($event.target.value)"
                    ></textarea>
                        </autoresizable-textarea>
                    </route-plan-contact-search>

                </div>
                <div class="flex-1 border-r border-gray-200 px-0 py-0">
                    <div v-if="job.status!=='Awaiting'" class="text-sm m-0 px-2 py-1" style="white-space: pre-wrap">
                        {{ job.materials ? job.materials : "&nbsp;" }}
                    </div>
                    <autoresizable-textarea :height="getHeight" v-else>
                <textarea
                    placeholder="Materials..."
                    class="text-sm px-2 py-1 mb-0 border-0 shadow-none relative hover:z-10 focus:z-20 resize-none"
                    :class="backgroundColor()"
                    type="text"
                    ref="description"
                    v-model="job.materials"
                    @input="save()"
                    @focus="editingMaterials()"
                    rows="1"
                ></textarea>
                    </autoresizable-textarea>
                </div>
            </template>
            <template v-else>
                <div class="flex-1 border-l border-r border-gray-200 px-0 py-0">
                    <div class="w-full px-0 py-0">
                        <div class="border-gray-200 bg-gray-50 border-b text-xs text-gray-500 font-semibold py-1 px-2">
                            Address
                        </div>
                        <div class="px-0 py-0 ">
                            <div v-if="job.status!=='Awaiting'" class="text-sm m-0 px-2 py-1"
                                 style="white-space: pre-wrap">
                                {{ job.address ? job.address : "&nbsp;" }}
                            </div>
                            <route-plan-address-search
                                v-else
                                class="col-span-full"
                                #default="{ open, query, setQuery }"
                                @selected:packageAddress="addressSelected"
                                :top="true"
                            >
                                <autoresizable-textarea>
                    <textarea
                        placeholder="Address..."
                        class="text-sm px-2 py-1 mb-0 border-0 shadow-none relative hover:z-20 focus:z-20 resize-none "
                        :class="backgroundColor()"
                        type="text"
                        ref="address"
                        v-model="job.address"
                        rows="1"
                        @input="setQuery($event.target.value);save()"
                        @focus="editingAddress($event.target,open);setQuery($event.target.value)"
                    ></textarea>
                                </autoresizable-textarea>
                            </route-plan-address-search>
                        </div>
                    </div>
                    <div class="w-full px-0 py-0">
                        <div
                            class="border-gray-200 bg-gray-50 border-t border-b text-xs text-gray-500 font-semibold py-1 px-2">
                            Contact
                        </div>
                        <div class="px-0 py-0">
                            <div v-if="job.status!=='Awaiting'" class="text-sm m-0 px-2 py-1"
                                 style="white-space: pre-wrap">
                                {{ job.contact ? job.contact : "&nbsp;" }}
                            </div>
                            <route-plan-contact-search
                                v-else
                                class="col-span-full"
                                #default="{ open, query, setQuery }"
                                @selected:deliveryContact="contactSelected"
                                :top="true"
                            >
                                <autoresizable-textarea>
                    <textarea
                        placeholder="Contact..."
                        class="text-sm px-2 py-1 mb-0 border-0 shadow-none relative hover:z-10 focus:z-20 resize-none"
                        :class="backgroundColor()"
                        type="text"
                        ref="contact"
                        v-model="job.contact"
                        rows="1"
                        @input="setQuery($event.target.value);save()"
                        @focus="editingContact($event.target,open);setQuery($event.target.value)"
                    ></textarea>
                                </autoresizable-textarea>
                            </route-plan-contact-search>

                        </div>

                    </div>
                    <div class="w-full px-0 py-0">
                        <div
                            class="border-gray-200 bg-gray-50 border-t border-b text-xs text-gray-500 font-semibold py-1 px-2">
                            Materials
                        </div>
                        <div class="px-0 py-0">
                            <div v-if="job.status!=='Awaiting'" class="text-sm m-0 px-2 py-1"
                                 style="white-space: pre-wrap">
                                {{ job.materials ? job.materials : "&nbsp;" }}
                            </div>
                            <autoresizable-textarea v-else>
                <textarea
                    placeholder="Materials..."
                    class="text-sm px-2 py-1 mb-0 border-0 shadow-none relative hover:z-10 focus:z-20 resize-none"
                    :class="backgroundColor()"
                    type="text"
                    ref="description"
                    v-model="job.materials"
                    @input="save()"
                    @focus="editingMaterials()"
                    rows="1"
                ></textarea>
                            </autoresizable-textarea>
                        </div>

                    </div>
                </div>
            </template>
            <div class="w-6 flex-shrink-0 ml-2 mt-1">
                <ui-dropdown menu-class="p-3 w-56" v-if="(job.status==='Awaiting')||clipboard.length">
                    <template #default="{ toggle }">
                        <button @click="toggle"
                                class="w-5 h-5 flex items-center justify-center text-gray-300 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:z-10 relative rounded">
                            <i class="fa fa-ellipsis-h fa-fw"></i>
                        </button>
                    </template>
                    <template #menu="{ close }">
                        <ui-dropdown-item icon="fas fa-cut" @click="cutJob();close();" v-if="job.status==='Awaiting'">
                            Cut
                        </ui-dropdown-item>
                        <ui-dropdown-item icon="fas fa-copy" @click="copyJob();close();">Copy</ui-dropdown-item>
                        <ui-dropdown-item icon="fas fa-paste" @click="pasteJobs();close();" v-if="clipboard.length">
                            {{ 'Paste (' + clipboard.length + ' jobs)' }}
                        </ui-dropdown-item>
                        <hr v-if="clipboard.length" class="m-1.5"/>
                        <ui-dropdown-item icon="fas fa-clipboard" @click="clearClipboard();close();"
                                          v-if="clipboard.length">
                            {{ 'Clear Clipboard (' + clipboard.length + ' jobs)' }}
                        </ui-dropdown-item>
                        <hr v-if="job.status==='Awaiting'" class="m-1.5"/>
                        <ui-dropdown-item icon="fas fa-trash" danger @click="removeJob();close();"
                                          v-if="job.status==='Awaiting'">Delete Job
                        </ui-dropdown-item>
                    </template>
                </ui-dropdown>
            </div>
        </div>
        <div class="w-full h-4" v-if="singleColumn"></div>
    </div>
</template>

<script>
import AutoresizableTextarea from "../../ui/AutoresizableTextarea";
import {isNull} from "lodash";
import UiDropdown from "../../ui/UiDropdown.vue";
import UiDropdownItem from "../../ui/UiDropdownItem.vue";
import RoutePlanAddressSearch from "./RoutePlanAddressSearch.vue";

export default {
    components: {RoutePlanAddressSearch, UiDropdownItem, UiDropdown, AutoresizableTextarea},
    props: {
        job: Object,
        clipboard: Array,
        singleColumn: false,
    },
    data() {
        return {
            focussed: false,
        }
    },
    computed: {},
    methods: {
        isNull,
        getHeight(el) {
            let max = 0;
            if (!this.singleColumn) {
                for (let area of el.closest('.draggable').getElementsByTagName('textarea')) {
                    area.setAttribute('style', 'height:auto')
                }
                for (let area of el.closest('.draggable').getElementsByTagName('textarea')) {
                    max = Math.max(max, area.scrollHeight);
                }
                for (let area of el.closest('.draggable').getElementsByTagName('textarea')) {
                    area.setAttribute('style', 'height:' + max + 'px;overflow-y:hidden;')
                }
            } else {
                for (let area of el.closest('.draggable').getElementsByTagName('textarea')) {
                    area.setAttribute('style', 'height:auto')
                    let height = area.scrollHeight
                    area.setAttribute('style', 'height:' + height + 'px;overflow-y:hidden;')
                }
            }
            if (this.focussed) {
                this.focussed.open();
            }
            return max + 'px';
        },
        addressSelected(e) {
            this.job.address = e.address.join("\n");
            this.save();
            this.$nextTick(() => {
                const el = this.focussed.el
                this.focussed = false
                this.getHeight(el);
            })
        },
        contactSelected(e) {
            this.job.contact = e.name;
            if (e.phone) this.job.contact += "\n" + e.phone;
            if (e.phone2) this.job.contact += "\n" + e.phone2;
            this.save();
            this.$nextTick(() => {
                const el = this.focussed.el
                this.focussed = false
                this.getHeight(el);
            })
        },
        removeJob() {
            this.$emit('removeJob', this.job)
        },
        cutJob() {
            this.$emit('cutJob', this.job)
        },
        copyJob() {
            this.$emit('copyJob', this.job)
        },
        pasteJobs() {
            this.$emit('pasteJobs', this.job)
        },
        clearClipboard() {
            this.$emit('clearClipboard', this.job)
        },
        save() {
            this.$emit('updatedJob', this.job)
        },
        backgroundColor() {
            if (this.job.status === 'Complete') {
                return 'bg-green-50';
            }
            if (this.job.status === 'Unable to Complete') {
                return 'bg-red-50';
            }
            return 'bg-white';
        },
        editingAddress(el, open) {
            this.focussed = {el: el, open: open};
            open();
        },
        editingContact(el, open) {
            this.focussed = {el: el, open: open};
            open();
        },
        editingMaterials() {
            this.focussed = false;
        }
    },
}
</script>
